<template>
  <main class="html-page home-page articles-page">
<main class="soro-content"><div class="container"><div id="soro-blog"></div></div></main>
    
      <a class="whatsapp" href="https://wa.me/5551991544590" aria-label="Falar pelo WhatsApp"><span></span></a>
    
  </main>
</template>

<script>
export default {
  name: 'ArtigosView',
  mounted() {
    document.title = "Artigos | Imaginar";
  },
};
</script>
